"use client";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { contactInfo as data } from "@/lib/data/partners";
import { Mail, Clock } from "lucide-react";

const accent = "var(--color-emerald)";

export function ContactInfo() {
  return (
    <Section id="contact-info" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-emerald)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-10 grid sm:grid-cols-2 gap-5">
          {data.contacts.map((c, i) => (
            <Reveal key={c.email} delay={i * 60}>
              <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
                <div className="flex items-center gap-3">
                  <span className="grid place-items-center h-9 w-9 rounded-lg" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                    <Mail className="h-4 w-4" style={{ color: accent }} />
                  </span>
                  <span className="eyebrow-tiny font-bold" style={{ color: accent }}>{c.label}</span>
                </div>
                <div className="mt-3">
                  <a href={`mailto:${c.email}`} className="text-sm font-semibold underline-offset-2 hover:underline" style={{ color: accent }}>{c.email}</a>
                  {c.note ? <p className="text-xs text-[rgb(var(--fg-muted))] mt-1">{c.note}</p> : null}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={500}>
          <div className="mt-8 grid sm:grid-cols-2 gap-3">
            {data.hours.map((h, i) => (
              <div key={i} className="glass rounded-2xl p-4 flex items-center gap-3" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 12%, transparent)` }}>
                <Clock className="h-4 w-4 shrink-0" style={{ color: accent }} />
                <div>
                  <div className="text-xs font-semibold" style={{ color: accent }}>{h.label}</div>
                  <div className="text-xs text-[rgb(var(--fg-muted))] mt-0.5">{h.body}</div>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
